(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "./utils/types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("./utils/types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.types);
    global.actionToolkit = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, _types) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createActionNamespace = createActionNamespace;

  function createActionNamespace(namespace) {
    return {
      createActionCreator: (type, payloadCreator) => {
        assertString('type', type);
        return createActionCreator(formatActionType(namespace, type), payloadCreator);
      },
      createAsyncActionCreators: (type, payloadCreators, meta) => {
        assertString('type', type);
        return createAsyncActionCreators(formatActionType(namespace, type), payloadCreators, meta);
      }
    };
  }

  function assertString(label, value) {
    if (!(0, _types.isString)(value)) {
      throw new Error(`"${label}" must be a string`);
    }
  }

  function formatActionType(namespace, type) {
    return `${namespace}/${type}`;
  }

  function createActionCreator(type, payloadCreator = () => ({}), meta) {
    function actionCreator(...args) {
      return createAction(type, payloadCreator(...args), meta);
    }

    actionCreator.type = type;

    actionCreator.toString = () => `${type}`;

    return actionCreator;
  }

  function createAction(type, payload, meta) {
    return {
      type,
      payload,
      meta
    };
  }

  function createAsyncActionTypes(type) {
    return {
      REQUEST: `${type}_REQUEST`,
      SUCCESS: `${type}_SUCCESS`,
      FAILURE: `${type}_FAILURE`
    };
  }

  function createAsyncActionCreators(type, payloadCreators, meta = {}) {
    if (!(0, _ramda.isNil)(meta.idKey)) {
      assertString('idKey', meta.idKey);
    }

    const {
      REQUEST,
      SUCCESS,
      FAILURE
    } = createAsyncActionTypes(type);
    const [requestPayloadCreator, successPayloadCreator, failurePayloadCreator] = payloadCreators;
    return {
      request: createActionCreator(REQUEST, requestPayloadCreator, meta),
      succeeded: createActionCreator(SUCCESS, successPayloadCreator, meta),
      failed: createActionCreator(FAILURE, failurePayloadCreator, meta)
    };
  }
});